import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { getFruitsBetByRoundId } from "./originals-games-api";

class SearchFruitsBet extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: false, data: {}, query: "" };
  }

  fetch() {
    this.setState({ loading: true });

    getFruitsBetByRoundId(this.state.query)
      .then((data) => this.setState({ data: data[0] || {} }))
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const data = this.state.data;

    if (this.state.loading) {
      return (
        <div className="bet-page">
          <h2>Loading...</h2>
        </div>
      );
    }

    return (
      <div className="bet-page">
        <div className="user-search-row">
          <input
            value={this.state.query}
            onChange={(e) => {
              this.setState({ query: e.target.value });
            }}
            placeholder="Type a Bet (hash) ID "
          />

          <button
            disabled={this.state.isLoading}
            className="red"
            onClick={() => this.fetch()}
          >
            {this.state.isLoading ? "Loading..." : "Search"}
          </button>
        </div>

        <div className="row">
          <div className="col-md-6">
            <pre>{JSON.stringify(data, null, 4)}</pre>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SearchFruitsBet);
